import { Draggable, Droppable } from '@hello-pangea/dnd';
import { transportationKeys } from '../../../../../../../consts/conditions';

import ConditionBody from '../ConditionBody';
import ConditionalInput from '../ConditionalInput';
import classNames from 'classnames';
import ConditionBtnWithLine from '../ConditionBtnWithLine';
import AddFilterBtn from '../AddFilterBtn';
import FilterColumnCard from '../FilterColumnCard';
import { FaPlus } from 'react-icons/fa6';

import React from 'react';
import { Button, Checkbox, Flex, rem } from '@mantine/core';
import { MdDragIndicator } from 'react-icons/md';
import { FilterColumnCardWrapperStyle } from '../../style';

export const DraggableTransformation = ({
  isChildrenGroup,
  cuurentItem,
  filterTypes,
  onChangeOperator,
  onChangeThenInputType,
  onChangeThen,
  onSelectItem,
  onSelectCondition,
  parentFilterTypeId,
  onDeleteSelectedItems,
  onAddFilterType,
  onChangeElseInputType,
  onChangeElseValue,
  addCondition,
  selectedItems,
  onChangeFunction,
  onChangeInputType,
  onChangeInput,
  onChangeColumn,
  columns,
  onAddListItem,
  onRemoveListItem,
  onChangeSelectedColumns,
  onChangeBrowserUse
}) => {
  return (
    <>
      <div id="grid-table-draggable-transformation-root" className="condition-box">
        {isChildrenGroup && !cuurentItem && (
          <div
            id="grid-table-draggable-transformation-checkbox-line"
            className={classNames('checkbox_line', {
              ['group-checkbox']: cuurentItem?.conditions?.length > 0
            })}
          >
            <div className="line" />
            <input
              type="checkbox"
              className="checkbox"
              checked={selectedItems?.includes(cuurentItem?.id)}
              onClick={() => onSelectItem(cuurentItem?.id)}
            />
          </div>
        )}

        <div id="grid-table-draggable-transformation-list" className="filter-types">
          <Droppable droppableId={cuurentItem?.id} key={cuurentItem?.id}>
            {provided =>
              filterTypes
                .filter(item => item.conditions.length)
                .map((item, idx) => {
                  const filterTypeId = parentFilterTypeId || item.id;

                  return (
                    <div
                      key={item.id}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{ width: '100%' }}
                    >
                      <div
                        id={`grid-table-draggable-transformation-card-${item.id}`}
                        className={classNames('filter_card', {
                          ['isChildren']: isChildrenGroup,
                          ['noBorderTop']: true,
                          ['noBorderBottom']: item.label !== transportationKeys.REPLACE,
                          ['isFilter']: (cuurentItem || item).label === transportationKeys.FILTER,
                          ['showAfterLine']: !isChildrenGroup && cuurentItem?.conditions?.length > 0
                        })}
                      >
                        {!isChildrenGroup &&
                          (cuurentItem || item).label === transportationKeys.REPLACE && (
                            <div className="when">When</div>
                          )}

                        <div
                          id={`grid-table-draggable-transformation-content-${item.id}`}
                          className={classNames('filter_content', {
                            ['showAfterLine']:
                              !isChildrenGroup && cuurentItem?.conditions?.length > 0
                          })}
                        >
                          <ConditionBtnWithLine
                            id={`grid-table-draggable-transformation-condition-${item.id}`}
                            label={item.conditionLabel}
                            disableDelete={!selectedItems?.length > 0}
                            disableGroup={!selectedItems?.length > 0}
                            onClickGroup={() => addCondition(item.id, 'group', filterTypeId)}
                            onClickDelete={() => onDeleteSelectedItems(filterTypeId)}
                            withActions={
                              !isChildrenGroup &&
                              item.label !== transportationKeys.FILL_FORWARD &&
                              selectedItems?.length > 0
                            }
                            onSelectCondition={val => onSelectCondition(filterTypeId, val, item.id)}
                          />

                          {item?.conditions?.map((value, idx) => {
                            if (value?.conditions?.length > 0)
                              return (
                                <Draggable key={value.id} draggableId={value.id} index={idx}>
                                  {(dragProvided, dragSnapshot) => {
                                    return (
                                      <FilterColumnCardWrapperStyle
                                        key={value.id}
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        style={{
                                          ...dragProvided.draggableProps.style,
                                          width: '100%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                          opacity: dragSnapshot.isDragging ? 0.5 : 1
                                        }}
                                      >
                                        <div
                                          className="drag-handle"
                                          {...dragProvided.dragHandleProps}
                                        >
                                          <MdDragIndicator
                                            color="#C1C2C5"
                                            width="20px"
                                            height="20px"
                                          />
                                        </div>

                                        <div className="checkbox_line">
                                          <Checkbox
                                            id={`grid-table-draggable-transformation-group-checkbox-${value.id}`}
                                            className="checkbox"
                                            checked={selectedItems.includes(value.id)}
                                            onClick={() => onSelectItem(value.id)}
                                            size={rem(16)}
                                          />
                                        </div>

                                        <Flex>
                                          <ConditionBody
                                            cuurentItem={value}
                                            filterTypes={[value]}
                                            selectedItems={selectedItems}
                                            onSelectItem={onSelectItem}
                                            addCondition={addCondition}
                                            isChildrenGroup={true}
                                            columns={columns}
                                            parentFilterTypeId={
                                              !isChildrenGroup ? filterTypeId : parentFilterTypeId
                                            }
                                            onChangeSelectedColumns={onChangeSelectedColumns}
                                            onChangeInput={onChangeInput}
                                            onChangeColumn={onChangeColumn}
                                            onChangeFunction={onChangeFunction}
                                            onChangeOperator={onChangeOperator}
                                            onChangeInputType={onChangeInputType}
                                            onSelectCondition={onSelectCondition}
                                            onAddListItem={onAddListItem}
                                            onRemoveListItem={onRemoveListItem}
                                          />
                                        </Flex>
                                      </FilterColumnCardWrapperStyle>
                                    );
                                  }}
                                </Draggable>
                              );

                            return (
                              <Draggable key={value.id} draggableId={value.id} index={idx}>
                                {(dragProvided, dragSnapshot) => (
                                  <div
                                    key={value.id}
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      opacity: dragSnapshot.isDragging ? 0.5 : 1
                                    }}
                                  >
                                    <FilterColumnCard
                                      key={value.id}
                                      operator={value.operator}
                                      column={value.column}
                                      func={value.function}
                                      value={value.value}
                                      inputType={value.inputType}
                                      columns={columns}
                                      errors={value.errors}
                                      dragHandleProps={{
                                        ...dragProvided.dragHandleProps
                                      }}
                                      hideFunction={true}
                                      isSelected={selectedItems.includes(value.id)}
                                      onSelect={() => onSelectItem(value.id)}
                                      onChangeSelectedColumns={(val, text) =>
                                        onChangeSelectedColumns(filterTypeId, value.id, val, text)
                                      }
                                      onChangeFunction={val =>
                                        onChangeFunction(filterTypeId, value.id, val)
                                      }
                                      onChangeInputType={val =>
                                        onChangeInputType(filterTypeId, value.id, val)
                                      }
                                      onChangeColumn={val =>
                                        onChangeColumn(filterTypeId, value.id, val)
                                      }
                                      onChangeOperator={val =>
                                        onChangeOperator(filterTypeId, value.id, val)
                                      }
                                      onAddListItem={val =>
                                        onAddListItem(filterTypeId, value.id, val)
                                      }
                                      onRemoveListItem={id =>
                                        onRemoveListItem(filterTypeId, value.id, id)
                                      }
                                      onChangeInput={val =>
                                        onChangeInput(filterTypeId, value.id, val)
                                      }
                                      showDate={true}
                                    />
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}

                          {provided.placeholder}

                          <AddFilterBtn
                            id={`grid-table-draggable-transformation-add-${item.id}`}
                            onClick={type =>
                              addCondition(item.id, type, parentFilterTypeId || filterTypeId)
                            }
                          />
                        </div>

                        {!isChildrenGroup &&
                          (cuurentItem || item).label === transportationKeys.REPLACE && (
                            <div className="then">
                              <p style={{ marginTop: '17px' }}>Then</p>
                              <ConditionalInput
                                hideFunction={item.label === transportationKeys.FILTER}
                                required={true}
                                columns={columns}
                                value={item?.then[item?.thenInputType]}
                                hiddenVariants={[]}
                                type={item?.thenInputType}
                                onChangeType={val =>
                                  onChangeThenInputType(filterTypeId, item.id, val)
                                }
                                onChangeSelectedColumns={(val, text) =>
                                  onChangeSelectedColumns(filterTypeId, item.id, val, text)
                                }
                                showDate={true}
                                onChangeValue={val => onChangeThen(filterTypeId, item.id, val)}
                                selectedSuggestions={item?.then?.ai_input?.selected_columns}
                                browserUse={item?.then?.ai_input?.browser_use}
                                onBrowserUseChange={val =>
                                  onChangeBrowserUse(filterTypeId, item.id, val)
                                }
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  );
                })
            }
          </Droppable>
        </div>
      </div>

      {!isChildrenGroup && cuurentItem?.label === transportationKeys.REPLACE && (
        <div className="post-condition">
          <Button
            id="grid-table-draggable-transformation-when"
            onClick={() => onAddFilterType(isChildrenGroup)}
            size="xs"
            leftSection={<FaPlus />}
            variant="outline"
          >
            When
          </Button>

          <div className="else">
            <p style={{ marginTop: '17px' }}>Else</p>
            <ConditionalInput
              columns={columns}
              value={cuurentItem?.elseValue[cuurentItem?.elseInputType]}
              type={cuurentItem?.elseInputType}
              required={false}
              onChangeType={val =>
                onChangeElseInputType(parentFilterTypeId || cuurentItem?.id, cuurentItem?.id, val)
              }
              showDate={true}
              onChangeValue={val =>
                onChangeElseValue(parentFilterTypeId || cuurentItem?.id, cuurentItem?.id, val)
              }
            />
          </div>
        </div>
      )}
    </>
  );
};
